// check if has one item on the last page
export default ({ total, perPage, page }) => ((total - 1) % perPage === 0)
                   && (Math.ceil(total / perPage) === page)
                   && page !== 1;
